import React from 'react';
import styled from 'styled-components';

const FinalConfirmation = styled.div`
  label {
    font-size: ${props => props.theme?.finalConfirmation?.fontSize};
    line-height: ${props => props.theme?.finalConfirmation?.lineHeight};
    color: ${props => props.theme?.finalConfirmation?.color};
    font-weight: ${props => props.theme?.finalConfirmation?.fontWeight};
  }
`;

export default FinalConfirmation;
